import { Icon } from "@iconify/react";
import { pascalCase } from "pascal-case";
import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { openUserModal } from "../../../redux/modalSlice";
import { pageSelector, updatePage } from "../../../redux/surveySlice";
import { deleteUser, resetUser, setUser } from "../../../redux/userSlice";
import BtnGroup from "../../baseui/buttons/BtnGroup";
import SearchField from "../../layouts/SearchField";
import Table from "../../layouts/Table";
import RemoveClient from "../clients/RemoveClient";
import UserDetail from "./UserDetail";

const UserList = ({ text, setText, users, getUsers }) => {
  const dispatch = useDispatch();
  const page = useSelector(pageSelector);
  const [viewUser, setViewUser] = useState(false);
  const [selected, setSelected] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const headers = [
    {
      Header: "Name",
      accessor: "firstName",
      Cell: (props) => {
        return (
          <p className="name">
            {props.row.original.firstName + " " + props.row.original.lastName}
          </p>
        );
      },
    },
    {
      Header: "Role",
      accessor: "role",
      Cell: (props) => {
        return props.row.original.role && pascalCase(props.row.original.role);
      },
    },
    {
      Header: "Email",
      accessor: "email",
      Cell: (props) => {
        return <p className="email">{props.row.original.email}</p>;
      },
    },
    {
      Header: "Address",
      accessor: "address",
      Cell: (props) => {
        return <p className="addressUser">{props.row.original.address}</p>;
      },
    },
    {
      Header: "Contact Number",
      accessor: "contact",
    },
    {
      Header: "Edit",
      accessor: "edit",
      Cell: (props) => {
        return (
          <ul className="actionTable">
            <li>
              <Link
                to="#"
                onClick={() => {
                  setSelected(props.row.original);
                  dispatch(resetUser());
                  setModalShow(true);
                }}
                className="edit"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.8833 6.3125C12.8833 6.3125 12.5213 10.8025 12.3113 12.6938C12.2113 13.5972 11.6533 14.1265 10.7393 14.1432C8.99994 14.1745 7.25861 14.1765 5.51994 14.1398C4.64061 14.1218 4.09194 13.5858 3.99394 12.6985C3.78261 10.7905 3.42261 6.3125 3.42261 6.3125"
                    stroke="#A2A9B0"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M13.8055 4.15999H2.50012"
                    stroke="#A2A9B0"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M11.627 4.15998C11.1037 4.15998 10.653 3.78998 10.5503 3.27732L10.3883 2.46665C10.2883 2.09265 9.94968 1.83398 9.56368 1.83398H6.74168C6.35568 1.83398 6.01701 2.09265 5.91701 2.46665L5.75501 3.27732C5.65234 3.78998 5.20168 4.15998 4.67834 4.15998"
                    stroke="#A2A9B0"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Link>
            </li>
            <li>
              <Link
                to="#"
                onClick={() => {
                  dispatch(setUser(props.row.original));
                  dispatch(openUserModal());
                }}
                className="edit"
              >
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.31805 13.1403C3.91266 13.1403 3.53385 13.0007 3.26137 12.7415C2.91579 12.4159 2.74965 11.9241 2.80946 11.3924L3.05535 9.2392C3.10187 8.83381 3.34777 8.2955 3.63354 8.00309L9.08971 2.22792C10.4521 0.785786 11.8743 0.745911 13.3164 2.10829C14.7586 3.47068 14.7984 4.89287 13.436 6.335L7.97987 12.1102C7.70075 12.4092 7.18238 12.6884 6.77698 12.7548L4.63705 13.1203C4.52407 13.127 4.42438 13.1403 4.31805 13.1403ZM11.223 2.10165C10.7113 2.10165 10.266 2.42064 9.8141 2.89914L4.35792 8.68096C4.22501 8.82052 4.07216 9.15281 4.04557 9.34554L3.79968 11.4988C3.7731 11.7181 3.82626 11.8975 3.94589 12.0105C4.06551 12.1235 4.24495 12.1633 4.46426 12.1301L6.60419 11.7646C6.79692 11.7314 7.11592 11.5586 7.24883 11.419L12.705 5.64384C13.5291 4.7666 13.8281 3.95582 12.6253 2.82604C12.0936 2.31431 11.635 2.10165 11.223 2.10165Z"
                    fill="#7E92A2"
                  />
                  <path
                    d="M12.1601 7.44485C12.1468 7.44485 12.1268 7.44485 12.1135 7.44485C10.0401 7.23883 8.37197 5.66378 8.05297 3.60359C8.0131 3.33112 8.19918 3.07858 8.47165 3.03206C8.74413 2.99218 8.99667 3.17826 9.04319 3.45074C9.29573 5.05902 10.5983 6.29513 12.2199 6.45463C12.4923 6.48121 12.6917 6.7271 12.6651 6.99958C12.6319 7.25212 12.4126 7.44485 12.1601 7.44485Z"
                    fill="#7E92A2"
                  />
                  <path
                    d="M14.5924 15.2869H2.63002C2.35755 15.2869 2.13159 15.0609 2.13159 14.7884C2.13159 14.5159 2.35755 14.29 2.63002 14.29H14.5924C14.8649 14.29 15.0908 14.5159 15.0908 14.7884C15.0908 15.0609 14.8649 15.2869 14.5924 15.2869Z"
                    fill="#7E92A2"
                  />
                </svg>
              </Link>
            </li>
          </ul>
        );
      },
    },
  ];

  useEffect(() => {
    dispatch(updatePage(1));
  }, []);

  const onDelete = async () => {
    let pageN = users.data.length === 1 ? (page > 1 ? page - 1 : page) : page;
    dispatch(deleteUser({ user: selected, pageNum: pageN }));
    setModalShow(false);
  };

  const openModal = () => {
    dispatch(resetUser());
    dispatch(openUserModal());
  };

  return (
    <>
      <Card className="card-main p-0 bg-transparent ">
        <Card.Title className="row mb-0 align-items-center px-0 pt-1">
          <div className="col-lg-6">
            <h5 className="mb-0">List of Users</h5>
          </div>
          <div className="col-lg-6">
            <div className="filterSearch">
              <div className="flex-1"></div>
              <SearchField text={text} onChange={setText} />

              <button className="btn cta-primary" onClick={() => openModal()}>
                <span>Add New</span>
                <i className="ms-2">
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 3.1665L8 13.8332"
                      stroke="white"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M13.3333 8.5L2.66663 8.5"
                      stroke="white"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </i>
              </button>
            </div>
          </div>
        </Card.Title>
      </Card>
      <Card className="card-main p-0 ">
        <Card.Body>
          <div className="userView">
            {users.data && (
              <Table
                headers={headers}
                gridData={users.data}
                isSearchAble
                searchText={text}
                totalCount={users.count}
                getData={getUsers}
                pageSize={20}
                selected="No user added"
                content="It seems like you have not added any user yet! Add one and view the content here."
                addNew="Add new user"
                onAdd={() => {
                  dispatch(resetUser());
                  dispatch(openUserModal());
                }}
              />
            )}
          </div>
        </Card.Body>
      </Card>

      <UserDetail show={viewUser} onHide={() => setViewUser(false)} />
      <RemoveClient
        type="User"
        details="Are you sure you want to delete this user?"
        show={modalShow}
        onHide={() => setModalShow(false)}
        onDelete={() => onDelete(selected)}
      />
    </>
  );
};

export default UserList;
